<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="80px">
        <!-- 问题序号 -->
        <el-form-item label="问题序号">
          <el-input
            v-model="queryParams.questionNum"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input
            v-model="queryParams.feedbackFormId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select
            clearable
            filterable
            v-model="queryParams.countryId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in nationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作 -->
        <el-button type="primary" size="small" @click="doSearch"
          >查询</el-button
        >
        <el-button type="primary" plain size="small" @click="handleResetQuery"
          >重置</el-button
        >
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn">
        <el-button type="text" size="mini" @click="back" icon="el-icon-back">返回</el-button>
      </div>
      <el-table
        ref="tableRef"
        v-loading="tableLoading"
        highlight-current-row
        :border="true"
        stripe
        :data="tableData"
        :row-class-name="tableRowClassName"
        fit
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 问题序号 -->
        <el-table-column
          prop="questionNum"
          label="问题序号"
          min-width="130px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="questionNum">
              <img
                v-if="scope.row.importantType === 1"
                class="title-icon"
                src="@/assets/img/import-icon.svg"
              />
              {{ scope.row.questionNum }}
            </div>
          </template>
        </el-table-column>
        <!-- 反馈单号 -->
        <el-table-column
          prop="feedbackFormId"
          label="反馈单号"
          min-width="120px"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('feedbackFormId', tableData)"
        >
        </el-table-column>
        <!-- 国家 -->
        <el-table-column
          prop="country"
          label="国家"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('country', tableData)"
        >
        </el-table-column>
        <!-- 处理类型 -->
        <el-table-column
          label="处理类型"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskType === 1">
              {{
                taskIdData[scope.row.lastTaskIdOne] &&
                scope.row.taskStatus !== 2
                  ? taskIdData[scope.row.lastTaskIdOne].taskName
                  : "--"
              }}
            </span>
            <span v-else-if="scope.row.taskType === 2">
              {{
                taskIdData[scope.row.lastTaskIdTwo] &&
                scope.row.taskStatus !== 2
                  ? taskIdData[scope.row.lastTaskIdTwo].taskName
                  : "--"
              }}
            </span>
            <span v-else-if="scope.row.taskType === 3">
              {{
                taskIdData[scope.row.lastTaskIdThree] &&
                scope.row.taskStatus !== 2
                  ? taskIdData[scope.row.lastTaskIdThree].taskName
                  : "--"
              }}
            </span>
          </template>
        </el-table-column>
        <!-- 判定类型 -->
        <el-table-column
          prop="reviewType"
          label="判定类型"
          min-width="130"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.reviewType === 1 ? "类型一" : "" }}
            {{ scope.row.reviewType === 2 ? "类型二" : "" }}
            {{
              scope.row.reviewType === 3 && scope.row.taskType === 1
                ? "类型三-应急措施"
                : ""
            }}
            {{
              scope.row.reviewType === 3 && scope.row.taskType === 2
                ? "类型三-根因分析"
                : ""
            }}
            {{
              scope.row.reviewType === 3 && scope.row.taskType === 3
                ? "类型三-永久方案"
                : ""
            }}
            {{ scope.row.reviewType === 4 ? "已有解决方案" : "" }}
          </template>
        </el-table-column>
        <!-- 故障来源 -->
        <el-table-column
          label="故障来源"
          min-width="120px"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('carType', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.carType === 0 ? "售前车" : "售后车" }}
          </template>
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          prop="carModel"
          label="车型"
          min-width="120px"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('carModel', tableData)"
        >
        </el-table-column>
        <!-- 车辆属性 -->
        <el-table-column
          label="车辆属性"
          min-width="120px"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('carAttribute', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.carAttribute === 0 ? "燃油车" : "电动车" }}
          </template>
        </el-table-column>
        <!-- 故障描述 -->
        <el-table-column
          prop="questionContent"
          label="故障现象描述"
          min-width="520px"
          align="center"
        >
          <template slot-scope="scope">
            <span class="gzms">{{ scope.row.questionContent }}</span>
          </template>
        </el-table-column>
        <!-- 当前节点处理人 -->
        <el-table-column
          prop="people"
          label="当前处理人"
          min-width="120px"
          :min-width="$getColumnWidth('people', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskStatus != 2">{{ scope.row.people }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <!-- 下一节点处理人 -->
        <el-table-column
          prop="nextPeople"
          label="下一处理人"
          min-width="120px"
          :min-width="$getColumnWidth('nextPeople', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskStatus != 2">{{
              scope.row.nextPeople
            }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          min-width="160"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('taskStatus', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.taskStatus === 0 ? "待处理" : "" }}
            {{ scope.row.taskStatus === 1 ? "处理中" : "" }}
            {{ scope.row.taskStatus === 2 ? "已关闭" : "" }}
          </template>
        </el-table-column>
        <!-- 提交人 -->
        <el-table-column
          prop="creator"
          label="提交人"
          min-width="120px"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('creator', tableData)"
        >
        </el-table-column>
        <!-- 提交时间 -->
        <el-table-column
          prop="submitTime"
          label="提交时间"
          min-width="160"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('submitTime', tableData)"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              size="mini"
              type="text"
              @click="handleLook(scope.row, scope.$index)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import {
  problemDetailListApi,
  problemExportApi,
  auditHistoryList,
} from "@/api/feedback";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem } from "@/util/dict";
import { setStorageNew, getSession } from "@/util/localStor";
import { taskIdData } from "./utils";
export default {
  components: {},
  mixins: [listCurd],
  props: {
    taskList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const {
      data = {},
      pageNum,
      pageSize,
    } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route.query.searchObj)
      : {};
    return {
      taskIdData,
      // 国家
      nationList: Object.values(getSession("nationList")).slice(1),
      // 车型
      carTypeList: [],
      pageNum: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      // 查询参数
      queryParams: {
        questionNum: data.questionNum || "",
        feedbackFormId: data.feedbackFormId || "",
        countryId: data.countryId || "",
        questionId: this.$route.params.taskId,
        createTime: this.$route.query.createTime || "",
      },
      // 表格数据
      listMethod: problemDetailListApi,
      exportLoading: false,
    };
  },
  created() {
    // 获取车型列表
    this.getCarTypeList();
    // 获取表格数据
    this.getList();

  },
  mounted() {
    this.$router.replace(this.$route.path);
  },
  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 查询参数
    getParams() {
      let params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      params.createTime = localStorage.getItem('createTime')
      if ((params.submitTime || []).length === 2) {
        params.submitTimeStart = params.submitTime?.[0];
        params.submitTimeEnd = params.submitTime?.[1];
      }
      delete params.submitTime;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 获取车型列表
    async getCarTypeList() {
      this.carTypeList = await getDictItem("carType");
    },
    // 查看
    handleLook(data = {}, index) {
      localStorage.setItem("problemId", data.questionId);


      setStorageNew("problemData", data);
      // 记录当前筛选条件
      this.recordSearchObj();
      this.$nextTick(() => {
        this.$router.push({
          path: "/problemDetailNew/" + data.taskId,
          // path: "/problemDetail/" + data.taskId,
          query: {
            questionNum: data.questionNum,
            searchObj: JSON.stringify({
              data: {
                ...this.getParams().data,
              },
              page: {
                pageNum: this.getColumnIndex(index),
                pageSize: 1,
              },
            }),
          },
        });
      });
    },

    // 颜色填充
    tableRowClassName({ row, rowIndex }) {
      if (row.taskStatus === 1 || row.taskStatus === 2) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.tabs-container {
  padding: 30px 0 15px 0;
  ::v-deep {
    .el-tabs__item {
      height: 30px;
      line-height: 30px;
    }
    .el-tabs__nav-wrap {
      padding: 0 7px 0 23px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }
}
.table-container {
  ::v-deep .el-tooltip {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .questionNum {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    img {
      position: absolute;
      left: -25px;
    }
  }
  .gzms {
    min-width: 220px;
    word-wrap: break-word;
    word-break: keep-all;
  }
}

::v-deep .el-table .success-row {
  background: #f0f9eb !important;
}
</style>
